import configService from "@/services/config";
import { askIQStream } from "@/api/askIQApi";
import {
  buildIqSuggestInspectionProtocolEndpoint,
  buildSuggestInspectionProtocolPayload,
} from "@/utils/buildSuggestInspectionProtocolPayload";

/**
 * Stream inspection protocol suggestions from IQ POST /suggest-inspection-protocol/.
 * @param {Object} params
 * @param {string} params.checkpointCriteria
 * @param {string} params.microlearningContent
 * @param {string[]} [params.existingSteps]
 * @param {AbortSignal} [params.signal]
 * @param {number} [params.timeoutMs] - Client-side max-wait before the stream is aborted.
 * @param {Function} [params.onThinkingUpdate]
 * @param {Function} [params.onComplete]
 * @param {Function} [params.onError]
 * @returns {Promise<{ data: Object }>}
 */
export async function suggestInspectionProtocolStream({
  checkpointCriteria,
  microlearningContent,
  existingSteps = [],
  signal,
  timeoutMs,
  onThinkingUpdate,
  onComplete,
  onError,
}) {
  const iqBaseUrl = configService.get("iqBaseUrl");
  const customEndpoint = buildIqSuggestInspectionProtocolEndpoint(iqBaseUrl);
  const customPayload = buildSuggestInspectionProtocolPayload({
    checkpointCriteria,
    microlearningContent,
    existingSteps,
  });

  return askIQStream({
    question: "",
    customEndpoint,
    customPayload,
    signal,
    timeoutMs,
    onThinkingUpdate,
    onComplete,
    onError,
  });
}
